import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import Settings from "Data/Settings";
import * as Topics from "Data/Topics";

/** Background image that can be hidden or replaced with a solid colour for accessibility */
export class Background extends PIXI.Container {

    protected _subscriptions: any[] = [];

    public constructor() {
        super();

        this.visible = (Settings.hideBackgroundImages === false);

        this._subscriptions.push(
            PubSub.subscribe(Topics.SETTINGS_CHANGED, this.onSettingsChanged.bind(this)),
        );

    }

    public destroy(pOptions?: Parameters<typeof PIXI.BitmapText.prototype.destroy>[0]): void {
        super.destroy(pOptions);
        this._subscriptions.forEach(PubSub.unsubscribe);
    }

    protected onSettingsChanged(pTopic: typeof Topics.SETTINGS_CHANGED, pSettings: Readonly<typeof Settings>): void {
        this.visible = (pSettings.hideBackgroundImages === false);
    }
}